import { StringDevUIField } from "./StringDevUIField";

export class StringDevFieldToggle extends StringDevUIField<boolean> {
  private checkbox: HTMLInputElement | null = null;
  private toggle: HTMLElement | null = null;

  build(): HTMLElement {
    const row = this.createRow();
    row.appendChild(this.createLabel());

    const toggle = document.createElement("label");
    toggle.setAttribute("data-stdg-toggle", "");
    toggle.setAttribute("data-checked", String(this.value));

    const hidden = document.createElement("input");
    hidden.type = "checkbox";
    hidden.checked = this.value;
    hidden.setAttribute("data-stdg-toggle-input", "");
    this.checkbox = hidden;
    this.toggle = toggle;

    const knob = document.createElement("span");
    knob.setAttribute("data-stdg-toggle-knob", "");

    hidden.addEventListener("change", () => {
      const next = hidden.checked;
      this.value = next;
      toggle.setAttribute("data-checked", String(next));
      this.emit(next);
    });

    toggle.appendChild(hidden);
    toggle.appendChild(knob);
    row.appendChild(toggle);
    this.root = row;
    return row;
  }

  setValue(value: boolean): void {
    this.value = value;
    if (this.checkbox) this.checkbox.checked = value;
    this.toggle?.setAttribute("data-checked", String(value));
  }

  override setDisabled(disabled: boolean): void {
    super.setDisabled(disabled);
    if (this.checkbox) this.checkbox.disabled = disabled;
    this.toggle?.setAttribute("aria-disabled", disabled ? "true" : "false");
  }
}
